/**
 * O simbolo da marca: a rosa dos ventos dentro do disco azul-marinho.
 *
 * COPIA, NAO ORIGINAL. Redesenhado em vetor a partir de uma imagem que o
 * Gustavo mandou em 20/10 (um print de 394 pixels, com fundo escuro em volta,
 * que nao serve como arquivo). Quando o vetor original aparecer, troque este
 * componente inteiro em vez de ajustar curva por curva aqui.
 *
 * O que a imagem mostra, e que esta reproduzido:
 *
 * - disco azul-marinho
 * - estrela de quatro pontas, branca, longa e fina
 * - miolo azul solido
 * - tres aneis de arcos, um arco por quadrante, abertos nos quatro eixos:
 *   o de fora fino e claro, o do meio grosso e azul, o de dentro branco
 * - as letras N, E, S, W dentro do disco, nas pontas
 *
 * As cores sao fixas, e nao `currentColor`: o simbolo e um selo com fundo
 * proprio, e tem que sair igual em qualquer lugar onde for colocado.
 */

/*
  Cada anel e um circulo tracejado: quatro tracos de 60 graus e quatro vaos
  de 30. A rotacao de 15 graus centra os tracos nas diagonais, e os vaos caem
  nos eixos, onde passam as pontas da estrela.
*/
function anel(raio: number) {
  const volta = 2 * Math.PI * raio;
  return `${(volta * 60) / 360} ${(volta * 30) / 360}`;
}

export function Marca({
  tamanho = 40,
  comLetras = true,
  className = '',
}: {
  tamanho?: number;
  /** Abaixo de uns 36px as letras viram sujeira. Desligue. */
  comLetras?: boolean;
  className?: string;
}) {
  return (
    <svg
      width={tamanho}
      height={tamanho}
      viewBox="0 0 72 72"
      role="img"
      aria-label="HCRM"
      className={className}
    >
      <title>HCRM</title>

      {/* 35.6 e nao 36: com o raio cheio, a suavizacao da borda era cortada nos quatro pontos onde o disco encosta no limite do desenho. */}
      <circle cx="36" cy="36" r="35.6" fill="#13355a" />

      <g fill="none" transform="rotate(15 36 36)">
        <circle cx="36" cy="36" r="25" stroke="#bfd9f0" strokeWidth="1.3" strokeDasharray={anel(25)} />
        <circle cx="36" cy="36" r="20.5" stroke="#4a90d9" strokeWidth="2.8" strokeDasharray={anel(20.5)} />
        <circle cx="36" cy="36" r="16" stroke="#ffffff" strokeWidth="1.6" strokeDasharray={anel(16)} />
      </g>

      {/* A estrela: pontas longas, cintura fina no miolo. */}
      <path
        d="M36 11 L38 34 L61 36 L38 38 L36 61 L34 38 L11 36 L34 34 Z"
        fill="#ffffff"
      />

      <circle cx="36" cy="36" r="5" fill="#3b82d6" />

      {comLetras ? (
        <g
          fill="#ffffff"
          fontSize="6.5"
          fontWeight="700"
          textAnchor="middle"
          fontFamily="var(--font-texto)"
        >
          <text x="36" y="9.2">
            N
          </text>
          <text x="65.4" y="38.3">
            E
          </text>
          <text x="36" y="68">
            S
          </text>
          <text x="6.6" y="38.3">
            W
          </text>
        </g>
      ) : null}
    </svg>
  );
}
